import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Select-root_1kHso",
  "small": "Select-small_hkRlW",
  "is-disabled": "Select-is-disabled_3VasA",
  "is-active": "Select-is-active_1j7W6",
  "is-readOnly": "Select-is-readOnly_2dTd-",
  "has-error": "Select-has-error_1KvJF",
  "block": "Select-block_ypwF7"
};
export class Select extends React.Component {
  static defaultProps = {
    active: false,
    disabled: false,
    readOnly: false,
    variant: ['default'],
    error: ''
  };
  renderItem = (item, index) => {
    if ('value' in item && !Array.isArray(item.value) && !Array.isArray(item.text)) {
      return /*#__PURE__*/_jsx("option", {
        value: item.value,
        children: item.text
      }, `key-${item.value}-${index}`);
    }
    return Object.keys(item).map(label =>
    // $FlowFixMe[invalid-computed-prop]
    Array.isArray(item[label]) ? /*#__PURE__*/_jsx("optgroup", {
      label: label,
      children: item[label].map(this.renderItem)
    }, label) : null);
  };
  oldValueExist = item => {
    const {
      value
    } = this.props;
    if ('value' in item) {
      return item.value === value;
    }
    return Object.keys(item).some(key =>
    // $FlowFixMe[invalid-computed-prop]
    Array.isArray(item[key]) ? item[key].some(this.oldValueExist) : false);
  };
  render() {
    const {
      active,
      className,
      disabled,
      readOnly,
      error,
      values,
      placeholder,
      variant,
      isField,
      popoverIcon,
      ...inputProps
    } = this.props;
    const selectClassName = clsx(styles.root, className, {
      'is-active': active,
      // $FlowFixMe[incompatible-use] // conflict between flow & eslint for default props
      [styles.block]: variant.indexOf('block') > -1,
      [styles['is-disabled']]: disabled,
      [styles['is-readOnly']]: readOnly,
      [styles['has-error']]: error,
      'has-error': error,
      // $FlowFixMe[incompatible-use] // conflict between flow & eslint for default props
      [styles.small]: variant.indexOf('small') > -1
    });
    const invalidValue = !values.some(this.oldValueExist);
    return /*#__PURE__*/_jsxs("select", {
      className: selectClassName,
      disabled: disabled,
      "aria-readonly": readOnly,
      ...inputProps,
      children: [placeholder && /*#__PURE__*/_jsx("option", {
        className: styles.placeholder,
        value: "",
        disabled: inputProps.required && !invalidValue,
        children: placeholder
      }), values.map(this.renderItem)]
    });
  }
}